import React from "react";
import "react-datepicker/dist/react-datepicker.css";

export default function InputField(props) {
  return (
    <>
      <input
        {...props?.field}
        className={`${props?.commonInputCss}  ${props?.proposalInputCss} ${props?.searchInputCss} ${props?.searchSelectCss}  `}
        type={props?.type}
        placeholder={props?.placeholder}
        readOnly={props?.readOnly}
        list={props?.list}
        // onChange={props?.onChange}
        style={
          props?.fieldState && props?.fieldState?.error
            ? { borderColor: "red" }
            : {}
        }
      />
    </>
  );
}
